import {HeaderRightSectionItemWrapper} from '@mds/mds-reactjs-library'

import UserAvatar from './UserAvatar'

const HeaderRightSection = [
  <HeaderRightSectionItemWrapper
    aria-label="avatar"
    horizontalLayoutComponent={UserAvatar}
    key="avatar"
    tooltip={false}
  />
]

export default HeaderRightSection
